import {
    Button,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
} from '@material-ui/core';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ActionHeader, FaqLink } from '..';
import en from '../../../../lang/en-us';
import { NoteModals } from '../../../../lib/NoteModals';
import TextInput from '../../../../lib/TextField';
import { sendPhoneOTP, sendMobileOTP, updateMobile } from '../../../../redux-store/actions/nct';
import { RootStateType } from '../../../../redux-store/reducers';
import {
    addDialCode,
    OTP_ACTIONS,
    REGISTER_WITH_MOBILE,
    UPDATE_MOBILE,
} from '../../../../utils/constants';
import { isError, showHelperText } from '../../commercial/Switch/utils';
import { nextScreen } from './flow';
import * as yup from 'yup';
import MobileRelationship from './MobileRelationship';

const { dashboard, common } = en;
const initialValues = {
    mobile: '',
    mobileRelationship: '',
};
const validationSchema = yup.object({
    mobileRelationship: yup.string().required(common.errors.relationship.mobileRequired),
});

function ChangeMobileNew(props: any) {
    const { mobile: existingMobile, userRegisteredWith } = props;

    useEffect(() => {
        if (userRegisteredWith == REGISTER_WITH_MOBILE) {
            if (!props.location.state) {
                props.history.replace('/');
                return;
            }
        }
    }, []);

    const mobileFormik = useFormik({
        initialValues,
        onSubmit: async ({ mobile, mobileRelationship }) => {
            const goTo = nextScreen(props.match.path);
            console.log(goTo);
            if (existingMobile.slice(3) === mobile) {
                alert('New mobile number should not be same as registered mobile number');
                mobileFormik.setFieldValue('mobile', '');
                return;
            }
            try {
                const {
                    images = [],
                    action = OTP_ACTIONS.NEW_MOBILE_ONINE_OTP,
                    flow,
                } = props.location.state || {};
                const { pan, pekrn } = props;
                let res = await props.sendMobileOTP({
                    mobile: addDialCode(mobile),
                    pan,
                    pekrn,
                    action,
                });
                const routeStateParams = {
                    mobile,
                    mobileRelationship,
                    ...(res || {}).body,
                    onSuccessNavigationUrl: props?.location?.state?.onSuccessNavigationUrl || '',
                    foliosToUpdate: props?.location?.state?.foliosToUpdate,
                    success: true,
                    images,
                    action,
                };

                props.history.replace(goTo, routeStateParams);
            } catch (err: any) {
                alert(err.message);
            }
        },
        validationSchema,
    });

    const handleMobileChange = (event: any) => {
        const { target } = event;
        const { value } = target;
        if (!isNaN(value) && (/^\d+$/.test(value) || !value) && value.length <= 10) {
            mobileFormik.setFieldValue('mobile', value);
        }
    };

    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.ChangeMobile.ChangeMobileHeading} />
            <div className="curved-bg-content">
                <img className="change-email-img" src="/images/change-email-img.png" alt="" />
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <h3 className="subheading">
                            {dashboard.ChangeMobile.newMobile.heading}
                            <span>{dashboard.ChangeMobile.newMobile.headingSpan}</span>
                        </h3>
                        {/* <p>{dashboard.ChangeMobile.newMobile.info}</p> */}
                        <TextInput
                            error={isError(mobileFormik, 'mobile')}
                            helperText={showHelperText(mobileFormik, 'mobile')}
                            value={mobileFormik.values.mobile}
                            onChange={handleMobileChange}
                            label="Enter Here"
                            name="mobile"
                        />
                        <MobileRelationship mobileFormik={mobileFormik} />
                    </div>
                    <FaqLink section={UPDATE_MOBILE} history={props.history} />
                    <div className="curved-bg-content-inner-bottom">
                        <Button
                            disabled={mobileFormik.values.mobile.trim().length < 10}
                            onClick={mobileFormik.handleSubmit as any}
                            className="customBtn"
                        >
                            {dashboard.changeEmail.buttonText}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({ ...authReducer, ...portfolio }),
    { sendPhoneOTP, sendMobileOTP, updateMobile },
)(ChangeMobileNew);
